import { FaInstagram, FaTiktok, FaTwitter } from 'react-icons/fa';

const SocialFollowBanner = () => {
  return (
    <div style={styles.container}>
      <div style={styles.inner}>
        <p style={styles.text}>SNSでリアルな雰囲気をチェックしよう！</p>
        <div style={styles.icons}>
          <a
            href="https://www.instagram.com/new_nightlife2"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
            title="Instagram"
            onMouseDown={handleTapEffect}
            onAnimationEnd={handleRemoveTapEffect}
          >
            <FaInstagram style={{ ...styles.icon, color: '#E1306C' }} />
          </a>
          <a
            href="https://www.tiktok.com/@new_nightlife"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
            title="TikTok"
            onMouseDown={handleTapEffect}
            onAnimationEnd={handleRemoveTapEffect}
          >
            <FaTiktok style={{ ...styles.icon, color: '#000' }} />
          </a>
          <a
            href="https://twitter.com/youraccount"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
            title="Twitter"
            onMouseDown={handleTapEffect}
            onAnimationEnd={handleRemoveTapEffect}
          >
            <FaTwitter style={{ ...styles.icon, color: '#1DA1F2' }} />
          </a>
        </div>
      </div>

      <style>
        {`
          @keyframes tapEffect {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.2); opacity: 0.7; }
            100% { transform: scale(1); opacity: 1; }
          }
          .tap-effect {
            animation: tapEffect 0.3s ease;
          }
        `}
      </style>
    </div>
  );
};

const handleTapEffect = (e) => {
  e.currentTarget.classList.add('tap-effect');
};

const handleRemoveTapEffect = (e) => {
  e.currentTarget.classList.remove('tap-effect');
};

const styles = {
  container: {
    background: 'linear-gradient(135deg, #ffd1dc, #e0bbff)',
    padding: '16px 12px 36px',
    textAlign: 'center',
    borderTop: '2px solid #ff69b4',
    boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.15)',
    width: '100%',
    boxSizing: 'border-box',
  },
  inner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
  },
  text: {
    fontSize: '16px',
    fontWeight: 700,
    color: '#ad1457',
    margin: 0,
    lineHeight: '1.5',
    wordBreak: 'break-word',
  },
  icons: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    flexWrap: 'wrap', 
  },
  link: {
    fontSize: '44px',
    backgroundColor: '#fff',
    border: '1.5px solid #f8bbd0',
    borderRadius: '50%',
    width: '56px',
    height: '56px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 3px 10px rgba(0,0,0,0.15)',
    transition: 'transform 0.25s ease, opacity 0.25s ease, box-shadow 0.25s ease',
    touchAction: 'manipulation',
  },
  icon: {
    fontSize: '32px',
  },
};

export default SocialFollowBanner;
